module.exports = __webpack_public_path__ + "img/exportBlack.e24ef999.svg";